<div class="aya-quote-step" *ngIf="courseSummary$ | async as courseSummary">
  <lx-card-container [title]="courseSummary.title">
    <div class="aya-quote-step__course-summary">
      <div class="aya-quote-step__course-summary__image-wrapper">
        <p-skeleton
          *ngIf="!loadedImage"
          [height]="skeletonImageHeight$ | async"
          styleClass="aya-quote-step__course-summary__image-wrapper__image-skeleton"
          [class.aya-quote-step__course-summary__image-wrapper__image-skeleton--loaded]="loadedImage"
        >
        </p-skeleton>
        <lx-image
          [image]="courseSummary.imageUrl"
          [width]="100"
          [height]="100"
          (loadedImage)="onImageLoaded()"
          alt="Course Image"
          class="aya-quote-step__course-summary__image-wrapper__image"
          [class.aya-quote-step__course-summary__image-wrapper__image--loaded]="loadedImage"
          data-qa="ayaQuoteStep_courseSummary_image"
        />
      </div>

      <div class="aya-quote-step__course-summary__description" data-qa="ayaQuoteStep_courseSummary_description">
        {{ courseSummary.description }}
      </div>
      <div class="aya-quote-step__course-summary__timetable" data-qa="ayaQuoteStep_courseSummary_timetable">
        <div class="aya-quote-step__course-summary__timetable__title" i18n data-qa="ayaQuoteStep_courseSummary_timetable_title">Timetable</div>
        <div class="aya-quote-step__course-summary__timetable__lessons-per-week" data-qa="ayaQuoteStep_courseSummary_timetable_lessonsPerWeek">
          <div
            class="aya-quote-step__course-summary__timetable__lessons-per-week__lessons"
            data-qa="ayaQuoteStep_courseSummary_timetable_lessonsPerWeek_lessons"
          >
            {{ courseSummary.courseData.lessonsPerWeek }}
          </div>
          <div class="aya-quote-step__course-summary__timetable__lessons-per-week__info">
            <div
              class="aya-quote-step__course-summary__timetable__lessons-per-week__info__description"
              i18n
              data-qa="ayaQuoteStep_courseSummary_timetable_lessonsPerWeek_info_description"
            >
              lessons per week
            </div>
            <div
              class="aya-quote-step__course-summary__timetable__lessons-per-week__info__hours"
              data-qa="ayaQuoteStep_courseSummary_timetable_lessonsPerWeek_info_hours"
            >
              {{ courseSummary.courseData.hoursPerWeek }}
            </div>
            <div
              class="aya-quote-step__course-summary__timetable__lessons-per-week__info__hours-label"
              i18n
              data-qa="ayaQuoteStep_courseSummary_timetable_lessonsPerWeek_info_hoursLabel"
            >
              hours
            </div>
          </div>
        </div>
        <div class="aya-quote-step__course-summary__timetable__lessons-breakdown">
          <span
            class="aya-quote-step__course-summary__timetable__lessons-breakdown__lesson"
            *ngFor="let lessonBreakdown of courseSummary.courseData.lessonsBreakdown"
          >
            <span
              class="aya-quote-step__course-summary__timetable__lessons-breakdown__lesson__sessions"
              data-qa="ayaQuoteStep_courseSummary_timetable_lessonsBreakdown_lesson_sessions"
              >{{ lessonBreakdown.sessions }}
            </span>
            <span
              class="aya-quote-step__course-summary__timetable__lessons-breakdown__lesson__title"
              data-qa="ayaQuoteStep_courseSummary_timetable_lessonsBreakdown_lesson_title"
              >{{ lessonBreakdown.title }}
            </span>
            <span
              class="aya-quote-step__course-summary__timetable__lessons-breakdown__lesson__hours"
              data-qa="ayaQuoteStep_courseSummary_timetable_lessonsBreakdown_lesson_hours"
              >{{ lessonBreakdown.hours }}
            </span>
            <span
              class="aya-quote-step__course-summary__timetable__lessons-breakdown__lesson__hours-description"
              i18n
              data-qa="ayaQuoteStep_courseSummary_timetable_lesson_lessonsBreakdown_hoursDescription"
              >hours</span
            >
          </span>
        </div>
      </div>
    </div>
  </lx-card-container>
  <lx-quote-step-footer></lx-quote-step-footer>
</div>
